// 공고의 '지원방법' 값 — 쉼표로 이은 문자열 (예: "사역자모아 지원, e-메일")
// 사이트 지원 게시판(국내·해외 사역지)은 사역자모아 지원이 항상 열려 있고, 교회가 다른 방법을 함께 고른다 (application-structure-final.md 2장)

export const SITE_APPLY_METHOD = '사역자모아 지원';

const isSiteMethod = (v: string) => /사역자모아/.test(v);

export const splitApplyhow = (value: unknown) =>
  String(value || '')
    .split(/\s*[,·/]\s*/)
    .map((v) => v.trim())
    .filter((v) => v && v !== '-');

/** 상세 화면 표시용 — 사역자모아 지원을 맨 앞에 */
export const applyhowWithSite = (value: unknown) =>
  [SITE_APPLY_METHOD, ...splitApplyhow(value).filter((v) => !isSiteMethod(v))].join(', ');

/** 고른 방법 → 저장값. 목록에 없는 기존 값(가져온 공고의 자유 입력 등)은 지우지 않는다 */
export const joinApplyhow = (selected: string[], siteApply: boolean) => {
  const list = selected.filter((v) => !isSiteMethod(v));
  return (siteApply ? [SITE_APPLY_METHOD, ...list] : list).join(', ');
};

// 가져온 공고 재작성 본문의 '지원 방법' 항목 → 사이트 지원 안내 (server importGuideline.withSiteApplyFact 와 같은 규칙)
const SITE_APPLY_LI_RE = /<li><strong>지원 방법<\/strong> : [^<]*<\/li>/g;
export const withSiteApplyFact = (html: string) =>
  html.replace(SITE_APPLY_LI_RE, "<li><strong>지원 방법</strong> : 이 공고의 '지원하기' 버튼으로 사역자모아에서 지원 (지원 내역이 기록됩니다)</li>");
